import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/images/new-content-login.png'
import _imports_1 from '@/images/logo-login.png'


const _withScopeId = n => (_pushScopeId("data-v-c4ec6ba6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "box-thumb"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"max-width":"70%"},
  src: _imports_0,
  preview: false
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "box-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "header-logo" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: "Acesso ao Sistema",
      preview: false
    })
  ])
], -1))
const _hoisted_7 = {
  key: 0,
  class: "content-account"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Crie sua conta")
], -1))
const _hoisted_9 = { class: "account-form" }
const _hoisted_10 = { class: "steps" }
const _hoisted_11 = {
  key: 0,
  class: "steps-form"
}
const _hoisted_12 = { class: "cp-one" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Nome completo")
], -1))
const _hoisted_14 = { class: "cp-two" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" CPF")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Data nascimento")
], -1))
const _hoisted_17 = { class: "cp-one" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, "Senha", -1))
const _hoisted_19 = { class: "form-terms" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Eu concordo com os ")
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" e ")
const _hoisted_22 = {
  key: 1,
  class: "steps-form"
}
const _hoisted_23 = {
  key: 0,
  class: "align-center"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "steps-action" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" Anterior ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Prosseguir ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Ir para o login ")
const _hoisted_29 = {
  key: 1,
  class: "content-account"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "account-header" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Crie sua conta")
], -1))
const _hoisted_31 = { class: "steps" }
const _hoisted_32 = {
  key: 0,
  class: "steps-form"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Para mim")
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Para o meu negócio")
const _hoisted_35 = {
  key: 1,
  class: "steps-form"
}
const _hoisted_36 = { class: "cp-one" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Nome empresarial")
], -1))
const _hoisted_38 = { class: "cp-two" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Cnpj")
], -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Telefone")
], -1))
const _hoisted_41 = { class: "cp-two" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" CEP")
], -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Cidade")
], -1))
const _hoisted_44 = { class: "cp-two" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Estado")
], -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Bairro/Distrito")
], -1))
const _hoisted_47 = { class: "cp-two" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Rua/Avenida")
], -1))
const _hoisted_49 = { class: "cp-two-lb" }
const _hoisted_50 = { class: "cp-icon-address" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Número ")
const _hoisted_52 = {
  key: 2,
  class: "steps-form"
}
const _hoisted_53 = { class: "cp-one" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Nome completo")
], -1))
const _hoisted_55 = { class: "cp-two" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" CPF")
], -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-two-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Data nascimento")
], -1))
const _hoisted_58 = { class: "cp-one" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" E-mail")
], -1))
const _hoisted_60 = { class: "cp-one" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Confirme o e-mail")
], -1))
const _hoisted_62 = { class: "cp-one" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "cp-one-lb" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f5222d"} }, "*"),
  /*#__PURE__*/_createTextVNode(" Senha")
], -1))
const _hoisted_64 = { class: "form-terms" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" Eu concordo com os ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" e ")
const _hoisted_67 = { key: 3 }
const _hoisted_68 = {
  key: 0,
  class: "align-center"
}
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { class: "steps-action" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" Anterior ")
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Prosseguir ")
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" Ir para o login ")
const _hoisted_74 = {
  key: 0,
  class: "terms"
}
const _hoisted_75 = {
  key: 1,
  class: "policy"
}
const _hoisted_76 = {
  key: 2,
  class: "content-footer"
}
const _hoisted_77 = {
  key: 1,
  class: "box-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_step = _resolveComponent("a-step")!
  const _component_a_steps = _resolveComponent("a-steps")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_CheckCircleFilled = _resolveComponent("CheckCircleFilled")!
  const _component_a_result = _resolveComponent("a-result")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_InfoCircleFilled = _resolveComponent("InfoCircleFilled")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_CloseCircleFilled = _resolveComponent("CloseCircleFilled")!
  const _component_ModalTerms = _resolveComponent("ModalTerms")!
  const _component_ModalPolicy = _resolveComponent("ModalPolicy")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_Footer = _resolveComponent("Footer")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_5, [
      _hoisted_6,
      (_ctx.isExternal)
        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_steps, {
                  current: _ctx.current,
                  "label-placement": "vertical"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsExternal, (item) => {
                      return (_openBlock(), _createBlock(_component_a_step, {
                        key: item.title,
                        title: item.title,
                        class: _normalizeClass({'step-completed': _ctx.success})
                      }, null, 8, ["title", "class"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["current"])
              ]),
              (_ctx.stepsExternal[_ctx.current].content == '1')
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_a_form, {
                      layout: "vertical",
                      model: _ctx.formEnterprise,
                      ref: "formRef",
                      class: "form"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_12, [
                          _createVNode(_component_a_form_item, {
                            rules: {
                                required: true,
                                message: 'Nome completo obrigatório!'
                            },
                            class: "cp"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13,
                              _createVNode(_component_a_input, {
                                value: _ctx.registrationExternal.name,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registrationExternal.name) = $event)),
                                placeholder: "Nome completo",
                                size: "large"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_a_form_item, {
                            rules: {
                                required: true,
                                message: 'Cpf obrigatório!'
                            },
                            class: "cp"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15,
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.registrationExternal.cpf,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registrationExternal.cpf) = $event)),
                                placeholder: "123.456.789-00",
                                size: "large"
                              }, null, 8, ["value"]), [
                                [_directive_maska, '###.###.###-##']
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, {
                            rules: {
                                required: true,
                                message: 'Data nascimento'
                            },
                            class: "cp"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_16,
                              _withDirectives(_createVNode(_component_a_input, {
                                value: _ctx.newValueDate,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newValueDate) = $event)),
                                placeholder: "DD/MM/AAAA",
                                style: {"width":"100%"},
                                size: "large",
                                onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.checkDate()))
                              }, null, 8, ["value"]), [
                                [_directive_maska, '##/##/####']
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_a_form_item, { class: "cp" }, {
                            default: _withCtx(() => [
                              _hoisted_18,
                              _createVNode(_component_a_input_password, {
                                value: _ctx.registrationExternal.password,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registrationExternal.password) = $event)),
                                placeholder: "*******",
                                size: "large"
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createVNode(_component_a_checkbox, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.AcceptTerms())),
                            class: "spaceRight"
                          }),
                          _createElementVNode("span", null, [
                            _hoisted_20,
                            _createElementVNode("a", {
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showModal(1))),
                              class: "text-link"
                            }, "Termos de Uso"),
                            _hoisted_21,
                            _createElementVNode("a", {
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showModal(2))),
                              class: "text-link"
                            }, "Política de Privacidade")
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.success)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_ctx.spin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                          _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          (_ctx.success)
                            ? (_openBlock(), _createBlock(_component_a_result, {
                                key: 0,
                                status: "success",
                                title: "Sua conta foi cadastrada com sucesso!",
                                "sub-title": "Agora você pode acessar o sistema pelo botão abaixo!",
                                class: "create-account-success"
                              }, {
                                icon: _withCtx(() => [
                                  _createVNode(_component_CheckCircleFilled, { class: "success-ic" })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                ((_ctx.current > 0 && !_ctx.success) && !_ctx.finalStep)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "btn-certificata",
                      style: {"margin-right":"8px"},
                      onClick: _ctx.prev
                    }, {
                      default: _withCtx(() => [
                        _hoisted_26
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (
                        (_ctx.current < _ctx.stepsExternal.length - 1 || _ctx.current == 0) &&
                        _ctx.stepsExternal.length !== _ctx.current
                        )
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 1,
                      type: "primary",
                      class: "btn-action-certificata",
                      size: "larger",
                      disabled: _ctx.canCreate,
                      onClick: _ctx.next
                    }, {
                      default: _withCtx(() => [
                        _hoisted_27
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.success && !_ctx.isCustomerPartner)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 2,
                      type: "primary",
                      class: "btn-action-certificata",
                      size: "larger",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToLogin()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_28
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_a_steps, {
                current: _ctx.current,
                "label-placement": "vertical"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (item) => {
                    return (_openBlock(), _createBlock(_component_a_step, {
                      key: item.title,
                      title: item.title,
                      class: _normalizeClass({'step-completed': _ctx.success})
                    }, null, 8, ["title", "class"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["current"])
            ]),
            (_ctx.steps[_ctx.current].content == '1')
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createVNode(_component_a_select, {
                    ref: "select",
                    value: _ctx.typeAccount,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.typeAccount) = $event)),
                    style: {"width":"100%","max-width":"300px"},
                    onChange: _ctx.handleChange,
                    size: "large",
                    class: "select-type-account"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select_option, { value: 1 }, {
                        default: _withCtx(() => [
                          _hoisted_33
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_select_option, { value: 2 }, {
                        default: _withCtx(() => [
                          _hoisted_34
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["value", "onChange"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.steps[_ctx.current].content == '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createVNode(_component_a_form, {
                    layout: "vertical",
                    model: _ctx.formEnterprise,
                    ref: "formRef",
                    class: "form"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                                required: true,
                                message: 'Nome empresarial obrigatório!'
                            },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_37,
                            _createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.name,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formEnterprise.name) = $event)),
                              placeholder: "Digite o nome da empresa",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                                required: true,
                                message: 'Cnpj obrigatório!'
                            },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_39,
                            _withDirectives(_createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.cpfCnpj,
                              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formEnterprise.cpfCnpj) = $event)),
                              placeholder: "12.3456.789/0001-12",
                              size: "large"
                            }, null, 8, ["value"]), [
                              [_directive_maska, '##.###.###/####-##']
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          rules: {
                                required: true,
                                message: 'Telefone obrigatório!'
                            },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_40,
                            _withDirectives(_createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.phone,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formEnterprise.phone) = $event)),
                              placeholder: "(12) 1234-4566",
                              size: "large"
                            }, null, 8, ["value"]), [
                              [_directive_maska, ['(##) ####-####', '(##) #####-####']]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'CEP obrigatório!'
                          },
                          onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setZipCode())),
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_42,
                            _withDirectives(_createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.zipCode,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formEnterprise.zipCode) = $event)),
                              placeholder: "12345-678",
                              size: "large"
                            }, null, 8, ["value"]), [
                              [_directive_maska, '#####-###']
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'Cidade obrigatório!'
                          },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_43,
                            _createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.city,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formEnterprise.city) = $event)),
                              placeholder: "Cidade",
                              disabled: _ctx.cep.localidade !== '',
                              size: "large"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'Estado'
                          },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45,
                            _createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.state,
                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formEnterprise.state) = $event)),
                              placeholder: "Estado",
                              disabled: _ctx.cep.uf !== '',
                              size: "large"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'Bairro/Distrito obrigatório!'
                          },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_46,
                            _createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.district,
                              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formEnterprise.district) = $event)),
                              placeholder: "Bairro/Distrito",
                              disabled: _ctx.cep.bairro !== '',
                              size: "large"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'Rua obrigatório!'
                          },
                          class: "cp-address"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48,
                            _createVNode(_component_a_input, {
                              value: _ctx.formEnterprise.address,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formEnterprise.address) = $event)),
                              placeholder: "Rua/Avenida",
                              disabled: _ctx.cep.logradouro !== '',
                              size: "large"
                            }, null, 8, ["value", "disabled"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { class: "cp-address-number" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_49, [
                              _createVNode(_component_a_tooltip, { title: "Deixe em branco se o endereço não possuir número." }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_50, [
                                    _createVNode(_component_InfoCircleFilled),
                                    _hoisted_51
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _createVNode(_component_a_input_number, {
                              style: {"width":"auto"},
                              value: _ctx.addressNumber,
                              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addressNumber) = $event)),
                              placeholder: "Número",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.steps[_ctx.current].content == '3')
              ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                  _createVNode(_component_a_form, {
                    layout: "vertical",
                    model: _ctx.formEnterprise,
                    ref: "formRef",
                    class: "form"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_53, [
                        _hoisted_54,
                        _createVNode(_component_a_form_item, {
                          rules: {
                        required: true,
                        message: 'Nome completo obrigatório!'
                      },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: _ctx.formIndividual.name,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formIndividual.name) = $event)),
                              placeholder: "Nome completo",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_55, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'Cpf obrigatório!'
                        },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_56,
                            _withDirectives(_createVNode(_component_a_input, {
                              value: _ctx.formIndividual.cpf,
                              "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formIndividual.cpf) = $event)),
                              placeholder: "123.456.789-00",
                              size: "large"
                            }, null, 8, ["value"]), [
                              [_directive_maska, '###.###.###-##']
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'Data nascimento obrigatório!'
                        },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_57,
                            _withDirectives(_createVNode(_component_a_input, {
                              value: _ctx.newValueDate,
                              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.newValueDate) = $event)),
                              placeholder: "DD/MM/AAAA",
                              style: {"width":"100%"},
                              size: "large",
                              onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.checkDate()))
                            }, null, 8, ["value"]), [
                              [_directive_maska, '##/##/####']
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'E-mail obrigatório!'
                        },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_59,
                            _createVNode(_component_a_input, {
                              value: _ctx.formIndividual.email,
                              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formIndividual.email) = $event)),
                              placeholder: "E-mail",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true,
                            message: 'E-mail obrigatório!'
                        },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_61,
                            _createVNode(_component_a_input, {
                              value: _ctx.confirmEmail,
                              "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.confirmEmail) = $event)),
                              placeholder: "E-mail",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_a_form_item, {
                          rules: {
                            required: true
                        },
                          class: "cp"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_63,
                            _createVNode(_component_a_input_password, {
                              value: _ctx.formIndividual.password,
                              "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formIndividual.password) = $event)),
                              placeholder: "*******",
                              size: "large"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createVNode(_component_a_checkbox, {
                          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.AcceptTerms())),
                          class: "spaceRight"
                        }),
                        _createElementVNode("span", null, [
                          _hoisted_65,
                          _createElementVNode("a", {
                            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showModal(1))),
                            class: "text-link"
                          }, "Termos de Uso"),
                          _hoisted_66,
                          _createElementVNode("a", {
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.showModal(2))),
                            class: "text-link"
                          }, "Política de Privacidade")
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.steps[_ctx.current].content == '4')
              ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                  (_ctx.spin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                        _createVNode(_component_a_spin, { indicator: _ctx.indicator }, null, 8, ["indicator"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        (_ctx.success && !_ctx.isPartner)
                          ? (_openBlock(), _createBlock(_component_a_result, {
                              key: 0,
                              status: "success",
                              title: "Sua conta foi cadastrada com sucesso!",
                              "sub-title": "Enviamos um link de verificação, acesse seu email para ativar sua conta!",
                              class: "create-account-success"
                            }, {
                              icon: _withCtx(() => [
                                _createVNode(_component_CheckCircleFilled, { class: "success-ic" })
                              ]),
                              _: 1
                            }))
                          : (_ctx.success && _ctx.isPartner && !_ctx.isFaciap)
                            ? (_openBlock(), _createBlock(_component_a_result, {
                                key: 1,
                                status: "success",
                                title: "Sua conta foi cadastrada com sucesso!",
                                "sub-title": "Você será redirecionado para a página de pagamento!",
                                class: "create-account-success"
                              }))
                            : (_ctx.success && _ctx.isPartner && _ctx.isFaciap)
                              ? (_openBlock(), _createBlock(_component_a_result, {
                                  key: 2,
                                  status: "success",
                                  title: "Sua conta foi cadastrada com sucesso!",
                                  "sub-title": "Você será redirecionado para a página de login!",
                                  class: "create-account-success"
                                }))
                              : (_openBlock(), _createBlock(_component_a_result, {
                                  key: 3,
                                  status: "error",
                                  title: "Falha ao criar uma conta",
                                  "sub-title": "Por favor verfique os passos anteriores",
                                  class: "create-account-error"
                                }, {
                                  icon: _withCtx(() => [
                                    _createVNode(_component_CloseCircleFilled, { class: "error-ic" })
                                  ]),
                                  _: 1
                                }))
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_70, [
              ((_ctx.current > 0 && !_ctx.success) && !_ctx.finalStep)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "btn-certificata responsive-btn",
                    style: {"margin-right":"8px"},
                    onClick: _ctx.prev
                  }, {
                    default: _withCtx(() => [
                      _hoisted_71
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (
                    (_ctx.current < _ctx.steps.length - 1 || _ctx.current == 0) &&
                    _ctx.steps.length !== _ctx.current
                    )
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    class: "btn-action-certificata",
                    size: "larger",
                    disabled: _ctx.canCreate,
                    onClick: _ctx.next
                  }, {
                    default: _withCtx(() => [
                      _hoisted_72
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]))
                : _createCommentVNode("", true),
              (_ctx.success && !_ctx.isCustomerPartner)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 2,
                    type: "primary",
                    class: "btn-action-certificata",
                    size: "larger",
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.goToLogin()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_73
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ])
          ])),
      _createVNode(_component_a_modal, {
        visible: _ctx.visible,
        "onUpdate:visible": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.visible) = $event)),
        width: "1000px",
        onOk: _ctx.handleOk,
        footer: null
      }, {
        default: _withCtx(() => [
          (_ctx.textVisible == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                _createVNode(_component_ModalTerms)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_75, [
                _createVNode(_component_ModalPolicy)
              ]))
        ]),
        _: 1
      }, 8, ["visible", "onOk"]),
      (_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("section", _hoisted_76, [
            _createVNode(_component_Footer)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("section", _hoisted_77, [
          _createVNode(_component_Footer)
        ]))
      : _createCommentVNode("", true)
  ]))
}